<template>
  <div class="container4">
    <h3>Loading</h3>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
    name: "InitialLoad",
    computed:
    {
      ...mapGetters("getModule",["getJoinedItemsFilter","ListArraysPopulated","isListReady","listHasData"]),
      ...mapGetters("authModule", ["userIsAuthenticated"]),
      myListIsReady(){
         return this.isListReady('Program');
      },
      myListDataStatus() {
        console.log('[InitialLoad.vue] myListDataStatus()....');
         return this.$store.state.getModule.Program.length != 0
      }
     },
    watch: {
        myListDataStatus: function(newval, oldval)
        {
          if (newval == true && oldval == false){
            console.log(`${Date.now()}-mytag----- [InitialLoad] myListDataStatus WATCH    ------------- newval=${newval}   oldval=${oldval}`)
            this.$router.push('Home');
          }
        }
    }
  };
</script>
<style>
div.container4 {
    height: 10em;
    position: relative }
div.container4 h1 {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%) }  
</style>

